import { OverlayTrigger, Tooltip as BsTooltip } from 'react-bootstrap';

const Tooltip = ({ title, children, placement = "bottom", ...props }) => {
    return (
        <OverlayTrigger
            placement={placement}
            overlay={<BsTooltip className='custom-tooltip'
            >{title}</BsTooltip>}
        >
            <span className="d-inline-block">
                {children}
            </span>
        </OverlayTrigger>
    );
};

export default Tooltip;